import * as React from "react";
import { Button } from "antd";
// import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export default function CommonButton({ children, onClick, icon: Icon }) {
  return (
    <Stack direction="row" spacing={2}>
      <Button
        //variant="outlined"
        type="primary"
        startIcon={Icon ? <Icon /> : null}
        onClick={onClick}
        className="bg-teal-700 text-white w-fit"
        block={false}
      >
        {children}
      </Button>
    </Stack>
  );
}
